import "antd/dist/antd.variable.min.css";
import "./index.less";
import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* to allow for repositioning of antd popup container */}
      {/* https://codesandbox.io/s/4j168r7jw0 */}
      <div id="area-container">
        <div id="area">
          <App />
        </div>
      </div>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
